module.exports = __webpack_public_path__ + "img/promotion-1.8b3aa283.png";